import {
  ACCEPTED_PRACTICE_PROGRAM,
  INITIALIZE_USER,
  LANGUAGE_CHANGE,
  LINK_PRACTICE,
  LOADED_CONNECTED_PRACTICES,
  LOGOUT,
  QUICK_SHARE_SET,
  QUICK_SHARE_STOP,
  REMOVE_SHARECODE,
  REMOVE_YEAR_OF_BIRTH,
  SET_PHONE_LANGUAGE,
  SET_SHARECODE,
  SET_YEAR_OF_BIRTH,
  UNLINK_PRACTICE,
  UserActions,
  UserState,
} from './types';

const initialState: UserState = {
  accountType: 'pat',
  code: '',
  communicationLanguage: '',
  country: '',
  created: 0,
  dateFormat: '1',
  dateOfBirth: 0,
  email: '',
  firstName: '',
  id: '',
  lastName: '',
  phoneLanguage: '',
  practices: {},
  programs: {},
  quickShare: {
    code: null,
    expiresAt: null,
  },
  system: {},
  timeFormat: '1',
  uiLanguage: '',
  uom: '0',
  yearOfBirth: 0,
};

export const userReducer = (state = initialState, action: UserActions): UserState => {
  switch (action.type) {
    case ACCEPTED_PRACTICE_PROGRAM:
      return {
        ...state,
        programs: {
          ...state.programs,
          [action.programId]: {
            ...state.programs[action.programId],
            ...{
              enrolled: true,
              enrolledPractice: action.practice.id,
              id: action.programId,
              name: action.practice.name,
            },
          },
        },
      };

    case INITIALIZE_USER:
      return {
        ...state,
        ...action.user,
      };

    case LANGUAGE_CHANGE:
      if (action.language === state.uiLanguage) {
        return state;
      }

      return {
        ...state,
        uiLanguage: action.language,
      };

    case LINK_PRACTICE:
      return {
        ...state,
        practices: {
          ...state.practices,
          [action.practice.id]: action.practice,
        },
      };

    case LOADED_CONNECTED_PRACTICES:
      return {
        ...state,
        practices: action.practices,
      };

    case REMOVE_SHARECODE:
      if (state.code !== action.code) {
        return state;
      }

      return {
        ...state,
        code: '',
      };

    case REMOVE_YEAR_OF_BIRTH:
      if (state.yearOfBirth !== action.yearOfBirth) {
        return state;
      }

      return {
        ...state,
        yearOfBirth: 0,
      };

    case SET_PHONE_LANGUAGE:
      return {
        ...state,
        phoneLanguage: action.language,
      };

    case SET_SHARECODE:
      return {
        ...state,
        code: action.code,
      };

    case SET_YEAR_OF_BIRTH:
      return {
        ...state,
        yearOfBirth: action.yearOfBirth,
      };

    case UNLINK_PRACTICE:
      const practices = { ...state.practices };
      const programs = { ...state.programs };

      delete practices[action.practiceId];

      const foundProg = Object.values(programs).find(
        (p) => p.enrolledPractice === action.practiceId
      );

      if (foundProg) {
        programs[foundProg.id] = { ...foundProg, enrolled: false };
      }

      return {
        ...state,
        practices,
        programs,
      };

    case QUICK_SHARE_STOP:
      if (state.quickShare?.code !== action.code) {
        return state;
      }

      return {
        ...state,
        quickShare: {
          ...initialState.quickShare,
        },
      };

    case QUICK_SHARE_SET:
      return {
        ...state,
        quickShare: {
          ...action.quickShare,
        },
      };

    case LOGOUT:
      return {
        ...initialState,
        country: state.country,
        uiLanguage: state.uiLanguage,
      };

    default:
      return state;
  }
};
